export var VisualNavigationType;
(function (VisualNavigationType) {
    VisualNavigationType["Default"] = "default";
    VisualNavigationType["Category"] = "category";
    VisualNavigationType["ContentTree"] = "content_tree";
})(VisualNavigationType || (VisualNavigationType = {}));
